// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled container for the Slideshow
export const SlideShowContainer = styled.div`
    /* Element disposition */
    position: relative;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Size */
    width: 80%;
    height: 250px;
`;

// Styled container for the slideshow images
export const SlideShowImagesContainer = styled.div`
    /* Size */
    height: 100%;
    width: 100%;

    /* Content disposition */
    display: flex;
    justify-content: center;
    align-items: center;
`;

// Styled image for the slideshow
export const SlideShowImage = styled.img`
    /* Size */
    width: 100%;
    height: 100%;

    /* Content disposition */
    object-fit: contain;
    object-position: center;
`;

// Styled offer banner
export const SlideShowOfferBanner = styled.div`
    /* Appearance */
    background-color: ${colors.secondaryRedBrown};
    box-shadow: 0px 4px 6px hsla(0, 0%, 0%, 0.3);

    /* Size */
    height: 25px;

    /* Element disposition */
    position: absolute;
    top: 0;
    left: 0;

    /* Content disposition */
    display: flex;
    align-items: center;
    justify-content: center;

    /* Spacing */
    margin-bottom: 15px;
    padding: 10px;
    padding-right: 15px;

    /* Visual effects */
    box-shadow: 0px 4px 6px hsla(0, 0%, 0%, 0.3);
    clip-path: polygon(0 0, 100% 0, calc(100% - 10px) 50%, 100% 100%, 0 100%);
`;

export const SlideShowOffer = styled.p`
    /* Appearance */
    color: ${colors.textWhite};
`;

// Styled button for the slideshow
export const SlideShowButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['left', 'right'].includes(prop),
})`
    /* Element disposition */
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;

    ${(props) => props.left && 'left: -50px;'}
    ${(props) => props.right && 'right: -61px;'}

    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }

    /* Mobile setup */
    @media (max-width: 600px) {
        ${(props) => props.left && 'left: -25px;'}
        ${(props) => props.right && 'right: -31px;'}
    }
`;

// Styled svg for button images
export const SlideShowButtonIcon = styled.svg`
    /* Appearance */
    fill: ${colors.primaryBeige};

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;

    /* Mobile setup */
    @media (max-width: 600px) {
        width: ${(props) => props.width * 0.7}px;
        height: ${(props) => props.width * 0.7}px;
    }
`;
